import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push
} from 'react-router-redux';
import {
  Button,
  Container,
  Header,
  Icon,
  List,
  Menu,
  Modal,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import AList from './../../auto/AList';

const PAGE_RANGE = 10;

class BusquedaCooperativasView extends Component {

  constructor (props) {
    super(props);

    this.CooperativaService = this.props.feathers.service('/api/cooperativas');
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <div>
        <AList
          pageRange={PAGE_RANGE}
          mapFunction={(cooperativa) => ({
            id: cooperativa.id,
            header: `${cooperativa.nombre}`,
            description: `Matricula Nacional: ${cooperativa.matriculaNacional} - Matricula Provincial: ${cooperativa.matriculaProvincial}`
          })}
          service={this.CooperativaService}
          options={{
            disableRemove: true,
            selectItem: (cooperativa) => {
              this.props.navigate(`/cooperativa/${cooperativa.id}`);
            }
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    BusquedaCooperativasView.mapStateToProps,
    BusquedaCooperativasView.mapDispatchToProps
  )(BusquedaCooperativasView)
);



// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/BusquedaCooperativasView.js